/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

import { CarouselProps } from 'react-multi-carousel'

import classes from './Carousel.module.scss'
import { CustomArrow, DefaultArrow } from './CarouselArrow'

type responsiveType = {
  largeDesktop?: number
  mediumDesktop?: number
  desktop?: number
  tablet?: number
  mobile?: number
  desktopPartialVisible?: number
  tabletPartialVisible?: number
}

export const responsive = ({
  largeDesktop = 4,
  mediumDesktop = 4,
  desktop = 4,
  tablet = 3,
  mobile = 1,
  desktopPartialVisible,
  tabletPartialVisible,
}: responsiveType) => ({
  largedesktop: {
    breakpoint: { max: 3000, min: 1799 },
    items: largeDesktop,
  },
  mediumDesktop: {
    breakpoint: { max: 1799, min: 1439 },
    items: mediumDesktop,
  },
  desktop: {
    breakpoint: { max: 1439, min: 959 },
    items: desktop,
    partialVisibilityGutter: desktopPartialVisible,
    paritialVisibilityGutter: desktopPartialVisible,
  },
  tablet: {
    breakpoint: { max: 959, min: 719 },
    items: tablet,
    partialVisibilityGutter: tabletPartialVisible,
    paritialVisibilityGutter: tabletPartialVisible,
  },
  mobile: {
    breakpoint: { max: 719, min: 0 },
    items: mobile,
  },
})

export const ButtonGroup = ({
  next,
  previous,
  white,
  noMagnet,
  btnClass,
  ...rest
}: any) => {
  const {
    carouselState: { currentSlide, slidesToShow, totalItems },
  } = rest
  return !noMagnet ? (
    <div className={`${btnClass || classes['carousel-container--arrows']}`}>
      <CustomArrow
        isLeft
        disabled={currentSlide === 0}
        white={white}
        onClick={() => previous()}
      />
      <CustomArrow
        isLeft={false}
        disabled={currentSlide + slidesToShow === totalItems}
        white={white}
        onClick={() => next()}
      />
    </div>
  ) : (
    <div className={`container ${classes['carousel-container--arrows']}`}>
      <DefaultArrow
        isLeft
        disabled={false}
        white={true}
        onClick={() => previous()}
      />
      <DefaultArrow
        isLeft={false}
        disabled={false}
        white={true}
        onClick={() => next()}
      />
    </div>
  )
}

export const defaultCarouselProps = (
  white = false,
  responsiveProps: responsiveType = {}
): CarouselProps => ({
  swipeable: true,
  draggable: true,
  showDots: false,
  responsive: responsive(responsiveProps),
  autoPlay: false,
  renderButtonGroupOutside: true,
  customButtonGroup: <ButtonGroup white={white} />,
  arrows: false,
  keyBoardControl: true,
  transitionDuration: 500,
  minimumTouchDrag: 80,
  children: null,
})
